<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper">
    <div class="row">
      <div class="col-lg-7 blue-background d-none d-lg-block">
        <div class="content d-flex flex-column justify-content-between">
          <div class="row">
            <b-col md="{5}">
              <img
                alt=""
                src="../assets/images/white_logo.png"
                style="height: 70px;"
              >
            </b-col>

            <locale-changer />
          </div>

          <div>
            <div class="header">
              <h1>
                {{ $t('login.irktSahiblriZBizneslriniPortalVasitsilRahatlqlaIda') }}
              </h1>

              <p>
                {{ $t('login.satnalanVTdarkTkilatlarHmininLogistikaIrktlriVTrSa') }}
              </p>
            </div>

            <div class=" header ">
              <p>{{ $t('sccTtbiqiMobilTelefonunuzaYklyin') }}</p>
              <div class="row ">
                <div class="col-3">
                  <a
                    href="https://apps.apple.com/us/app/supply-chain-community-scc/id1581189724"
                    target="_blank"
                  >
                    <img
                      src="../assets/images/store/apple.png"
                      class="w-100"
                      :alt="$t('login.appStore')"
                    >
                  </a>
                </div>
                <div class="col-3">
                  <a
                    href="https://play.google.com/store/apps/details?id=az.scc.scc"
                    target="_blank"
                  >
                    <img
                      src="../assets/images/store/google.png"
                      class="w-100"
                      :alt="$t('login.playMarket')"
                    >
                  </a>
                </div>
                <div class="col-5 text-white">
                  {{ $t('login.mobilTtbiqlriYklyinVDahaOxImkanlardanIstifadEdin') }}
                </div>
              </div>
            </div>
          </div>
          <div class="row" />
          <div class="row" />
        </div>
      </div>

      <div class="col-lg-5 white-background">
        <div class="content">
          <div class="mb-4 d-block d-lg-none">
            <img
              alt=""
              src="../assets/images/big_logo.png"
              style="height: 70px;"
            >
          </div>


          <ul class="nav nav-pills login-tab">
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{active: activeTab==='qr'}"
                href="#"
                @click="activeTab='qr'"
              >{{ $t('login.qrKodla') }} <br>
                {{ $t('login.daxilOl') }}</a>
            </li>
            <li
              v-if="showLi"
              class="nav-item"
            >
              <a
                class="nav-link"
                :class="{active: activeTab==='asan'}"
                href="#"
                @click="activeTab='asan'"
              >{{ $t('login.asanLoginl') }} <br> {{ $t('login.daxilOl') }}</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{active: activeTab==='phone'}"
                href="#"
                @click="activeTab='phone'"
              >{{ countryCode !== 'AZ' ? $t('login.emailIle') : $t('login.mobilNmr') }} <br> {{
                $t('login.daxilOl')
              }}</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{active: activeTab==='registration' || activeTab==='otp'}"
                href="#"
                @click="activeTab='registration'"
              >
                {{ $t('login.yeni') }} <br> {{ $t('login.qeydiyyat2') }}
              </a>
            </li>
          </ul>

          <div
            v-if="activeTab === 'qr'"
            class="card"
          >
            <div class="card-body">
              <h3>{{ $t('login.qrKodIlDaxilOl') }}</h3>
              <span>{{ $t('login.giriiTsdiqlmkNMobilTtbiqdSolMenyudanWebGiriBlmsini') }}</span>
            </div>

            <div class="card-body bg-light rounded m-3 p-5">
              <div
                v-if="webSessionKey"
                class="text-center"
              >
                <img
                  :src="`${mediaBase}/qr/${webSessionKey}.png`"
                  class="w-100 img-thumbnail"
                >
              </div>
              <div
                v-else
                class="alert alert-info"
              >
                {{ $t('login.yklnir') }}
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'asan'"
            class="card"
          >
            <div class="card-body">
              <h3>Digital login </h3>
              <p class="text-bold">
                {{
                  $t('login.deletedDigital')
                }}
              </p>

              <!-- Step 1: Enter PIN -->
              <div v-if="currentStepAsan === 'pin'">
                <label>{{ $t('login.enterFin') }} </label>
                <input
                  v-model="fin"
                  type="text"
                  placeholder="e.g. 65JRCMA"
                  class="form-control"
                >
                <button
                  class="btn btn-primary mt-2"
                  @click="handleResetPassword"
                >
                  {{ $t('login.resetPasswordByFin') }}
                </button>
              </div>

              <!-- Step 2: Enter Phone if not found -->
              <div v-else-if="currentStepAsan === 'phone'">
                <label>{{ $t('login.enterPhoneNumber') }}</label>
                <VuePhoneNumberInput
                  v-model="asanPhone"
                  :default-country-code="countryCode"
                  :required="true"
                  :no-example="true"
                  @update="asanPhoneUpdated"
                  @phone-number-blur="asanPhoneBlur"
                />

                <button
                  class="btn btn-primary mt-2"
                  @click="submitPhone"
                >
                  {{ $t('body.gndr') }}
                </button>
              </div>

              <!-- Step 3: OTP Confirmation -->
              <div v-else-if="currentStepAsan === 'otp'">
                <label>{{$t('login.enterOtp4Digit')}}</label>
                <input
                  v-model="asanOtp"
                  type="text"
                  maxlength="4"
                  placeholder="Enter OTP"
                  class="form-control"
                >
                <button
                  class="btn btn-primary mt-2"
                  @click="submitOtp"
                >
                  {{ $t('body.gndr') }}
                </button>
              </div>

              <!-- Step 4: New Password -->
              <!-- Step 4: New Password -->
              <div v-else-if="currentStepAsan === 'newPassword'">
                <label>Yeni şifrəni əlavə edin:</label>
                <div class="input-group mb-2">
                  <input
                    v-model="newPassword"
                    :type="passwordVisible ? 'text' : 'password'"
                    placeholder="**********"
                    class="form-control"
                  >
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click.prevent="passwordVisible = !passwordVisible"
                    >
                      <i :class="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'" />
                    </button>
                  </div>
                </div>
                <ul
                  v-if="scoreNewPassword.unmetRequirements.length"
                  class="text-danger mt-2"
                >
                  <li
                    v-for="req in scoreNewPassword.unmetRequirements"
                    :key="req"
                  >
                    {{ req }}
                  </li>
                </ul>
                <div class="progress mb-3">
                  <div
                    class="progress-bar"
                    :class="`bg-${scoreNewPassword.color}`"
                    :style="{ width: scoreNewPassword.percent + '%' }"
                    role="progressbar"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {{ scoreNewPassword.name }}
                  </div>
                </div>

                <label class="mt-2">{{ $t('login.passwordAgain') }}</label>
                <div class="input-group mb-2">
                  <input
                    v-model="confirmPassword"
                    :type="passwordVisible ? 'text' : 'password'"
                    placeholder="**********"
                    class="form-control"
                  >
                  <div class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click.prevent="passwordVisible = !passwordVisible"
                    >
                      <i :class="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'" />
                    </button>
                  </div>
                </div>
                <button
                  class="btn btn-primary mt-2"
                  :disabled="scoreNewPassword.percent < 100 || newPassword !== confirmPassword"
                  @click="submitNewPassword"
                >
                  {{ $t('login.changePassword') }}
                </button>
              </div>


              <!-- Success Message -->
              <div v-else-if="currentStepAsan === 'success'">
                <div class="alert alert-success">
                  {{ $t('login.passwordChanged') }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'phone'"
            class="card"
          >
            <div class="card-body">
              <h3>{{ countryCode !== 'AZ' ? $t('login.emailIlDaxilOl') : $t('login.mobilNmrIlDaxilOl') }}</h3>
              <span>{{
                countryCode !== 'AZ' ? $t('login.sistemDaxilOlmaqNemailNmrniziVIfrniziDaxilEdin') : $t('login.sistemDaxilOlmaqNMobilNmrniziVIfrniziDaxilEdin')
              }}</span>
            </div>
            <div class="card-body">
              <div class="p-4 border border-secondary rounded">
                <form @submit.prevent="login">
                  <div
                    v-if="countryCode==='AZ'"
                    class="form-group"
                  >
                    <label class="col-form-label pt-0">{{ $t('login.mobilNmr') }}</label>
                    <VuePhoneNumberInput
                      v-model="phone"
                      :default-country-code="countryCode"
                      :required="true"
                      :no-example="true"
                      @update="phoneUpdated($event)"
                      @phone-number-blur="phoneBlur($event)"
                    />
                  </div>
                  <div
                    v-else
                    class="form-group"
                  >
                    <label class="col-form-label pt-0">{{ $t('login.email') }}</label>
                    <input
                      v-model="phone"
                      class="form-control"
                      required
                      type="email"
                    >
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">{{ $t('login.ifr') }}</label>
                    <input
                      v-model="password"
                      autocomplete=""
                      class="form-control"
                      required=""
                      type="password"
                    >
                  </div>
                  <div class="form-group form-row mt-3 mb-0 d-flex justify-content-between align-items-center">
                    <button
                      class="btn btn-primary px-4"
                      type="submit"
                    >
                      {{ $t('login.giri') }}
                    </button>

                    <button
                      type="button"
                      class="btn btn-link"
                      @click="activeTab='forget'"
                    >
                      {{ $t('login.ifrmiUnutmuam') }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'forget'"
            class="card"
          >
            <div class="card-body">
              <h3>{{ $t('login.ifrnziUnutmusunuz') }}</h3>
              <span>{{ $t('login.mobilNmrniziDaxilEdinVIfrniziYenilyin') }}</span>
            </div>
            <div class="card-body">
              <div class="p-4 border border-secondary rounded">
                <form @submit.prevent="forget">
                  <div class="form-group">
                    <label class="col-form-label pt-0">{{ $t('login.mobilNmr') }}</label>
                    <VuePhoneNumberInput
                      v-model="phone"
                      :default-country-code="countryCode"
                      :required="true"
                      :no-example="true"
                      @update="phoneUpdated($event)"
                      @phone-number-blur="phoneBlur($event)"
                    />
                  </div>
                  <div class="form-group form-row mt-3 mb-0 d-flex justify-content-between align-items-center">
                    <button
                      class="btn btn-primary px-4"
                      type="submit"
                    >
                      {{ $t('login.ifrmiYenil') }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'forget_otp'"
            class="card"
          >
            <div class="card-body">
              <h3>{{ $t('login.ifrnziUnutmusunuz') }}</h3>
              <span>{{ $t('login.mobilNmrniziDaxilEdinVIfrniziYenilyin') }}</span>
            </div>
            <div class="card-body">
              <div class="p-4 border border-secondary rounded">
                <form @submit.prevent="forgetOtpVerify">
                  <div class="form-group">
                    <label class="col-form-label">{{
                      countryCode !== 'AZ' ? $t('login.mailGndrilmiSmsKod') : $t('login.nmrnizGndrilmiSmsKod')
                    }}</label>
                    <input
                      v-model="otp"
                      class="form-control"
                      required
                      type="number"
                    >
                  </div>

                  <div class="form-group form-row mt-3 mb-0">
                    <button
                      class="btn btn-primary px-4"
                      type="submit"
                    >
                      {{ $t('login.tsdiql') }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'registration'"
            class="card"
          >
            <div class="card-body">
              <h3>{{ $t('login.qeydiyyat') }}</h3>
              <span>{{ $t('login.hesabYaratVFunksiyalardanIstifadEt') }}</span>
            </div>
            <div class="card-body">
              <div class="p-4 border border-secondary rounded">
                <form @submit.prevent="register">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('login.ad') }}</label>
                        <input
                          v-model="name"
                          class="form-control"
                          required
                          type="text"
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('login.soyad') }}</label>
                        <input
                          v-model="surname"
                          class="form-control"
                          required
                          type="text"
                        >
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label pt-0">{{ $t('login.mobilNmr') }}</label>
                    <VuePhoneNumberInput
                      v-model="phone"
                      :default-country-code="countryCode"
                      :required="true"
                      :no-example="true"
                      @update="phoneUpdated($event)"
                      @phone-number-blur="phoneBlur($event)"
                    />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">E-mail</label>
                    <input
                      v-model="email"
                      class="form-control"
                      required
                      type="email"
                    >
                  </div>
                  <div class="form-group form-row mt-3 mb-0">
                    <button
                      class="btn btn-primary px-4"
                      type="submit"
                    >
                      {{ $t('login.qeydiyyatdanKe') }}
                    </button>
                  </div>
                  <br>
                  <div
                    class="btn-link"
                    style="background-color: #f8f9fa; padding: 10px; border-radius: 10px; margin-top: 10px;color:darkred; font-size: 14px; text-align: center; font-weight: bold; margin-bottom: 10px"
                  >
                    <a
                      href="https://www.youtube.com/watch?v=-vgdeDkT-04"
                      style="color:#ee162d "
                      target="_blank"
                    >
                      {{$t('login.registerVideo')}}
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div
            v-if="activeTab === 'otp'"
            class="card"
          >
            <div class="card-body">
              <h3>{{ $t('login.qeydiyyat') }}</h3>
              <span>{{ $t('login.hesabYaratVFunksiyalardanIstifadEt') }}</span>
            </div>
            <div class="card-body">
              <div class="p-4 border border-secondary rounded">
                <form @submit.prevent="otpVerify">
                  <div class="form-group">
                    <label class="col-form-label">{{
                      countryCode !== 'AZ' ? $t('login.mailGndrilmiSmsKod') : $t('login.nmrnizGndrilmiSmsKod')
                    }}</label>
                    <input
                      v-model="otp"
                      class="form-control"
                      required
                      type="number"
                    >
                  </div>

                  <div class="form-group form-row mt-3 mb-0">
                    <button
                      class="btn btn-primary px-4"
                      type="submit"
                    >
                      {{ $t('login.tsdiql') }}
                    </button>
                    <div
                      v-if="countdown > 0"
                      class="countdown"
                      style="margin-left: 30px"
                    >
                      {{ Math.floor(countdown / 60) }}:{{ String(countdown % 60).padStart(2, '0') }}
                    </div>

                    <div
                      v-if="countdown <= 0"
                      class=""
                    >
                      <button
                        style="margin-left: 30px"
                        class="btn btn-secondary px-4"
                        @click.prevent="resendRegister"
                      >
                        {{ $t('yenidn') }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- login page end-->
  </div>
  <!-- latest jquery-->
</template>

<script>
import {
  checkPhone,
  generateASANSession,
  generateWebSession,
  getGeneralSettings,
  otpVerify,
  userForget,
  userForgetVerify,
  userLogin,
  userMe,
  userRegister,
  userSetASANPass,
  userVerifyOtpNew
} from "@/repositories/GeneralDataRepository";
import {baseUrl, mediaBase} from "@/repositories/Repository";

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import {Carousel, Slide} from 'vue-carousel';
import LocaleChanger from "@/components/locale_changer.vue";

export default {
  name: 'Login',
  components: {LocaleChanger, VuePhoneNumberInput, Carousel, Slide},
  data() {
    return {
      countdown: 120, // Countdown from 120 seconds (2 minutes)
      timer2: null,
      mediaBase: mediaBase,
      webSessionKey: null,
      timer: null,
      statistics: [],
      phone: '',
      password: '',
      name: '',
      surname: '',
      email: '',
      showLi: true,
      otp: '',
      activeTab: 'qr',
      phoneObject: null,
      countryCode: '',
      currentStepAsan: 'pin', // steps: 'pin' → 'phone' → 'otp' → 'newPassword' → 'success'
      fin: '',
      asanPhone: '',
      asanOtp: '',
      newPassword: '',
      confirmPassword: '',
      passwordVisible: false, // New: to toggle password visibility

    }
  },
  computed: {
    scoreNewPassword() {
      // If no new password, return default values.
      if (!this.newPassword) {
        return {
          name: '',
          percent: 0,
          color: 'danger',
          unmetRequirements: []
        };
      }
      let requirementsMet = 0;
      const unmetRequirements = [];

      // Check for minimum 8 characters
      if (this.newPassword.length >= 8) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementLength"));
      }

      // Check for uppercase letter
      if (/[A-Z]/.test(this.newPassword)) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementUpperCase"));
      }

      // Check for lowercase letter
      if (/[a-z]/.test(this.newPassword)) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementLowerCase"));
      }

      // Check for digit
      if (/\d/.test(this.newPassword)) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementDigit"));
      }

      // Check for special character
      if (/[!@#$%^&*(),.?":{}|<>]/.test(this.newPassword)) {
        requirementsMet++;
      } else {
        unmetRequirements.push(this.$t("passwordChange.requirementSpecialChar"));
      }

      const score = requirementsMet * 20;
      let strengthLabel = "";
      let color = "";
      switch (requirementsMet) {
        case 1:
          strengthLabel = this.$t("passwordChange.veryWeak");
          color = "danger";
          break;
        case 2:
          strengthLabel = this.$t("passwordChange.weak");
          color = "warning";
          break;
        case 3:
          strengthLabel = this.$t("passwordChange.moderate");
          color = "warning";
          break;
        case 4:
          strengthLabel = this.$t("passwordChange.moderate");
          color = "warning";
          break;
        case 5:
          strengthLabel = this.$t("passwordChange.strong");
          color = "success";
          break;
        default:
          strengthLabel = this.$t("passwordChange.veryWeak");
          color = "danger";
      }

      return {
        name: strengthLabel,
        percent: score,
        color: color,
        unmetRequirements: unmetRequirements,
      };
    },
  },
  mounted() {
    this.fetchCountryCode();

    getGeneralSettings().then(d => {
      this.statistics = d;
    })
    this.generateWebSession();

    this.timer = setInterval(() => {
      if (this.webSessionKey) {
        userMe(this.webSessionKey).then(({code}) => {

          if (code === 200) {
            localStorage.setItem('token', this.webSessionKey);
            clearInterval(this.timer);

            window.location.href = this.$route.query['next'] || '/';
          }
        });
      }
    }, 5000);

    setTimeout(() => {
      this.generateWebSession();
    }, 60000)

  },
  methods: {
    startCountdown() {
      this.timer2 = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.stopCountdown();
        }
      }, 1000);
    },
    stopCountdown() {
      clearInterval(this.timer2);
      this.timer2 = null;
    },
    async fetchCountryCode() {
      let ip;
      try {
        const response = await fetch("https://api.ipify.org/?format=json")
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        ip = data.ip;
      } catch (error) {
        console.error("Failed to fetch ip", error);
      }

      try {
        const response = await fetch(`${baseUrl}/country?ip=${ip}`);

        // Check if the response is okay (status code in the range 200-299)
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const countryCode = data.countryCode;

        await this.$store.dispatch('auth/setCountry', countryCode); // Dispatch the action to update the Vuex state
        localStorage.setItem("country", countryCode);
        this.countryCode = countryCode

        // Update <li> tag visibility based on the country code
        this.showLi = (countryCode === "AZ");
        this.changeLanguage(countryCode === "AZ"? 'az':'en');

      } catch (error) {
        // Handle the error here
        console.error("Failed to fetch country code:", error);
      }
    },
    changeLanguage(lang) {
      localStorage.setItem('userLang', lang); // Store selected language in localStorage
      this.$i18n.locale = lang;
    },
    phoneUpdated(event) {
      this.phoneObject = event;
      if (event.isValid) {
        this.phone = event.formattedNumber;
      }
    },
    phoneBlur() {
      if (this.phoneObject && this.phoneObject.isValid) {
        this.phone = this.phoneObject.formattedNumber;
      } else {
        this.phone = '';
      }
    },
    asanPhoneUpdated(event) {
      this.phoneObject = event;

      // Only update asanPhone if the number is valid
      if (event.isValid) {
        this.asanPhone = event.formattedNumber;
      }
    },
    asanPhoneBlur() {
      if (this.phoneObject && this.phoneObject.isValid) {
        this.asanPhone =  this.phoneObject.formattedNumber;
      } else {
        this.asanPhone = '';
      }
    },

    login: function () {
      if (this.phone !== "" && this.password !== '') {
        let phone
        if (this.countryCode === 'AZ') {
          phone = this.phoneObject.formattedNumber.replace(/\D/g, '');

        } else {
          phone = this.phone;
        }

        userLogin(phone, this.password).then(({code, message, token}) => {

          if (code === 200) {
            localStorage.setItem("token", token);
            if (window.self !== window.top) {
              // If inside an iframe, open the redirect page in a new tab/window
              window.open(this.$route.query['next'] || '/', '_blank');
            } else {
              // If not inside an iframe, navigate as usual
              window.location.href = this.$route.query['next'] || '/';
            }
          } else if (code === 401) {
            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("login.nomreveyashifreyalnishdir"),
              icon: 'warning',
            })
          } else {
            this.$swal({
              title: `Error ${code} !`,
              text: message
            })
          }

        });
      }
    },

    forget: function () {
      if (this.phone !== "") {
        let phone = this.phoneObject.formattedNumber.replace(/\D/g, '');
        userForget(phone).then(({code, message, reason}) => {

          if (code === 200) {

            this.activeTab = 'forget_otp';


          } else if (code === 400) {
            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("login.nomreyalnishdir"),
              icon: 'warning',
            })
          } else if (code === 423) {
            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("login.bloklanib") + reason,
              icon: 'warning',
            })
          } else {
            this.$swal({
              title: `Error ${code} !`,
              text: message
            })
          }

        });
      }
    },


    forgetOtpVerify: function () {
      if (this.otp !== "") {
        let phone = this.phoneObject.formattedNumber.replace(/\D/g, '');
        let otp = this.otp.replace(/\D/g, '');
        userForgetVerify(phone, otp).then(({code, message, token}) => {

          if (code === 200) {
            localStorage.setItem("token", token);
            window.location.href = '/auth/changePassword';
          } else if (code === 401 || code === 404) {
            this.$swal({
              title: `Xəta !`,
              text: this.$t("login.shifreyalnishdir"),
              icon: 'error',
            })
          } else {
            this.$swal({
              title: `Error ${code} !`,
              text: message,
              icon: 'error',
            })
          }

        });
      }
    },
    resendRegister: function () {
      this.register();
      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        text: this.$t("login.registerResend"),
        icon: 'warning',
      })
    },
    register: function () {
      if (this.phone !== "" && this.name !== '' && this.surname !== '' && this.email !== '') {
        let phone = this.phoneObject.formattedNumber.replace(/\D/g, '');
        userRegister(phone, this.email, this.name, this.surname, this.countryCode).then(({code, message, token}) => {

          if (code === 200) {
            localStorage.setItem("temp_token", token);
            this.startCountdown();
            this.activeTab = 'otp';
          } else if (code === 409) {
            if (this.countryCode === 'AZ') {
              this.$swal({
                title: this.$t("generalModal.warningTitle"),
                text: this.$t("login.alreadyReg"),
                icon: 'warning',
              })
            } else {
              this.$swal({
                title: this.$t("generalModal.warningTitle"),
                text: this.$t("login.alreadyRegXarici"),
                icon: 'warning',
              })
            }
          } else if (code === 410) {
            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("login.alreadyRegMail"),
              icon: 'warning',
            })
          } else {
            this.$swal({
              title: `Error ${code} !`,
              text: message,
              icon: 'error',
            })
          }

        });
      }
    },


    otpVerify: function () {
      if (this.otp !== "") {
        let otp = this.otp.replace(/\D/g, '');
        let temp_token = localStorage.getItem('temp_token');
        otpVerify(temp_token, otp).then(({code, message}) => {

          if (code === 200) {
            localStorage.setItem("token", temp_token);
            window.location.href = '/auth/changePassword';
          } else {
            this.$swal({
              title: `Error ${code} !`,
              text: this.$t("userCompanyAdminDetails.otpNotCorrect"),
              icon: 'error',
            })
          }

        });
      }
    },

    // Step 1: Handle reset password request with entered PIN
    async handleResetPassword() {
      if (!this.fin) {
        this.$swal("Please enter your PIN");
        return;
      }
      try {
        // Initially, asanPhone is empty so it should return hasPhone false
        const response = await checkPhone(this.fin, this.asanPhone);
        console.log(response)

        if (response.data.hasPhone === "false") {
          // Ask for phone number input
          this.currentStepAsan = 'phone';
        } else {
          // If already associated, move directly to OTP
          this.currentStepAsan = 'otp';
        }
      } catch (error) {
        console.error(error);
        this.$swal("Error checking phone");
      }
    },

    // Step 2: Submit phone number entered by user
    async submitPhone() {
      if (!this.asanPhone) {
        this.$swal("Please enter your phone number");
        return;
      }
      try {
        const response = await checkPhone(this.fin, '994'+this.asanPhone);
        console.log(response)
        if (response.data.hasPhone === "true") {
          this.currentStepAsan = 'otp';
        } else {
          this.$swal("The phone number is not found. Please check and try again.");
        }
      } catch (error) {
        console.error(error);
        this.$swal("Error checking phone");
      }
    },

    // Step 3: Submit OTP
    async submitOtp() {
      if (!this.asanOtp || this.asanOtp.length !== 4) {
        this.$swal("Please enter the 4-digit OTP");
        return;
      }
      try {
        const response = await userVerifyOtpNew('994'+ this.asanPhone, this.asanOtp);
        console.log(response)
        if (response.isVerified) {
          this.currentStepAsan = 'newPassword';
        } else {
          this.$swal("OTP verification failed");
        }
      } catch (error) {
        console.error(error);
        this.$swal("Error verifying OTP");
      }
    },

    // Step 4: Submit new password
    async submitNewPassword() {
      if (!this.newPassword || this.newPassword !== this.confirmPassword) {
        this.$swal("Şifrələr uyğun gəlmir");
        return;
      }
      // Optionally, you can also check if the strength is 100%:
      if (this.scoreNewPassword.percent < 100) {
        this.$swal("Şifrə tələblərə uyğun deyil");
        return;
      }
      try {
        // Note: Adjust the phone formatting if needed.
        const formattedPhone = '994' + this.asanPhone;
        const response = await userSetASANPass(this.fin, formattedPhone, this.newPassword);
        console.log(response);
        if (response.phone) {
          this.currentStepAsan = 'success';
        } else {
          this.$swal("Failed to set new password");
        }
      } catch (error) {
        console.error(error);
        this.$swal("Error setting new password");
      }
    },
    generateWebSession() {
      generateWebSession().then(data => {
        if (data.code === 200) {
          this.webSessionKey = data.key
        } else {
          this.$swal({
            title: `Error ${data.code} !`,
            text: data.message,
            type: "error"
          }).then(() => {
            window.location.reload();
          })
        }
      })
    },

    asanSession() {
      generateASANSession().then(data => {
        if (data.code === 200) {
          window.location.href = 'https://asan.scc.az?transaction=' + data.key
        } else {
          this.$swal({
            title: `Error ${data.code} !`,
            text: data.message,
            type: "error"
          }).then(() => {
            window.location.reload();
          })
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.asan-button {
  background: url('@/assets/images/asan.png') no-repeat center #FFFFff;
  background-size: 100% 100%;
  border: none;
}

.blue-background {
  background: url('@/assets/images/login_bg.png') no-repeat right top #FFFFff;
  background-size: cover;
  padding: 50px;

  .content {
    min-height: calc(100vh - 100px);
    max-width: 650px;
    margin: 0 auto;

    .header {
      margin: 50px 0;

      h1 {
        font-size: 38px;
        font-weight: 500;
        color: #fff;
        margin-bottom: 40px;
      }

      p {
        font-size: 20px;
        color: white;
      }
    }

    .statistics-card {
      background: rgba(255, 255, 255, 0.1);
      color: white;
      margin-right: 10px;

      h4 {
        font-size: 30px;
        color: white;
      }

      span {
        color: white;
        font-size: 14px;
      }

      .icon-bg {
        color: rgba(#1E44C6, 0.5);
      }

    }
  }
}

.white-background {
  background: #fff;

  .content {
    max-width: 550px;
    margin: 100px auto 20px;
    @media screen and (min-width: 1000px) {
      margin: 150px auto 20px;
    }

  }


  .login-tab {
    margin: 10px 0;

    .nav-item {
      margin-right: 10px;

      .nav-link {
        border: 1px solid rgba(#6390F8, 0.1);
        color: #5D6B82;
        padding: 13px 25px;
        font-size: 13px;
        line-height: 1.2;
        text-align: center;

        &.active {
          background: rgba(#2062FB, 0.1);
        }
      }
    }
  }

  card {
    min-height: 50vh;
  }

}

::v-deep .VueCarousel-slide {
  margin-right: 0 !important;
}

::v-deep .VueCarousel-pagination {
  text-align: left;
}

.border-secondary {
  border-color: rgba(#20419E, 0.1) !important;
}


</style>
